var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7028",
    "data-name": "Rectangle 7028",
    width: 20,
    height: 20,
    transform: "translate(-17083 -19181)",
    fill: "#4972f4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28938",
    "data-name": "Group 28938",
    transform: "translate(17093 19190)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3036",
    "data-name": "Ellipse 3036",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(-17093 -19190)",
    fill: "#f5f8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6353",
    "data-name": "Mask Group 6353",
    transform: "translate(0 1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26949",
    "data-name": "Group 26949",
    transform: "translate(-7.678 1.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27877",
    "data-name": "Group 27877",
    transform: "translate(-17075.322 -19180.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30601",
    "data-name": "Path 30601",
    d: "M599.585,1136.983v-10.141a.564.564,0,0,1,.564-.564H601.3a.564.564,0,0,1,.565.564v10.141l1.9-1.925a.564.564,0,0,1,.812.008l.791.833a.565.565,0,0,1-.007.785l-4.21,4.282a.566.566,0,0,1-.8,0l-4.253-4.285a.564.564,0,0,1-.009-.786l.788-.833a.567.567,0,0,1,.813-.008Z",
    transform: "translate(-595.932 -1126.278)",
    fill: "#4972f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30601-2",
    "data-name": "Path 30601",
    d: "M599.586,1130.431v10.141a.564.564,0,0,0,.564.564H601.3a.565.565,0,0,0,.565-.564v-10.141l1.9,1.925a.564.564,0,0,0,.812-.008l.791-.833a.565.565,0,0,0-.007-.785l-4.21-4.282a.566.566,0,0,0-.8,0l-4.254,4.285a.564.564,0,0,0-.009.786l.789.832a.567.567,0,0,0,.813.008Z",
    transform: "translate(-585.527 -1126.038)",
    fill: "#4972f4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.fb3ad289428dc090d30b171b9dc3bf86.svg";
export { ForwardRef as ReactComponent };